(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-fancy-slideshow"] && !Shopify.designMode) return;
  try {
    
class KsFancySlideshow extends HTMLElement {
  constructor () {
    super()

    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=')
      script.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(script)
    }

    this.myInterval = setInterval(() => {
      this.init()
    }, 100);

    document.addEventListener('shopify:section:load', () => {
      if (event.target.querySelector('.ks-fancy-slideshow')) {
        this.init()
      }
    })
  }

  init () {    
    if (!window.Swiper) return

    const sliderElem = this.querySelector('.swiper')

    const navigation = {
      enabled: sliderElem.dataset.swiperNavigation === 'true',
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next' 
    }
  
    const pagination = {
      enabled: sliderElem.dataset.swiperPagination === 'bullets' || sliderElem.dataset.swiperPagination === 'fraction',
      el: '.swiper-pagination',
      type: sliderElem.dataset.swiperPagination,
      dynamicBullets: false,
      dynamicMainBullets: 2,
      renderFraction: function (currentClass, totalClass) {
        return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
      }
    }

    const effect = sliderElem.dataset.swiperEffect
  
    const scrollbar = {
      enabled: sliderElem.dataset.swiperPagination === 'scrollbar',
      el: sliderElem.querySelector('.swiper-scrollbar'),
      draggable: true
    }
  
    const speed = Number(sliderElem.dataset.swiperSpeed || 300)
  
    const autoplay = sliderElem.dataset.swiperAutoplay === '0'
      ? undefined
      : { delay: Number(sliderElem.dataset.swiperAutoplay) * 1000 }

    const creativeEffect = {
      prev: { translate: [0, 0, -400],},
      next: { translate: ['100%', 0, 0]},
    }

    console.log(sliderElem.dataset.swiperSpacing)

    const breakpoints = {
      0: {
        slidesPerView: sliderElem.dataset.swiperPartial === 'true' ? 1.4 : 1,
        spaceBetween: Math.round(Number(sliderElem.dataset.swiperSpacing) * .75)
      },
      750: {
        slidesPerView: sliderElem.dataset.swiperPartial === 'true' ? 1.3 : 1,
        spaceBetween: Number(sliderElem.dataset.swiperSpacing)
      },
      990: {
        slidesPerView: sliderElem.dataset.swiperPartial === 'true' ? 1.2 : 1,
        spaceBetween: Number(sliderElem.dataset.swiperSpacing)
      }
    }

    this.slider = new window.Swiper(sliderElem, {
      navigation,
      pagination,
      scrollbar,
      effect,
      speed,
      autoplay,
      creativeEffect,
      breakpoints,
      centeredSlides: true,
      loop: true,
      watchSlidesProgress: true,
      fadeEffect: { crossFade: true },
      mousewheel: { enabled: true, forceToAxis: true },
      on: {
      }
    })

    clearInterval(this.myInterval)
  }
}
customElements.define('ks-fancy-slideshow', KsFancySlideshow)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-marquee"] && !Shopify.designMode) return;
  try {
    
class KsMarquee extends HTMLElement {
  constructor () {
    super()

    this.init()

    document.addEventListener('shopify:section:load', (e) => {
      console.log(e.target) 
      if (e.target.querySelector('.ks-marquee')) {
        init()
      }
    })
  }

  init () {
    const list = this.querySelector('ul')
    console.log(list)
    const marqueeWidth = list.scrollWidth
    console.log(list.scrollWidth)
    const marqueeLength = list.querySelectorAll('li').length 

    list.insertAdjacentHTML('beforeEnd', list.innerHTML)

    list.querySelectorAll('li').forEach((item, index) => {
      if (index >= marqueeLength) {
        item.setAttribute('aria-hidden', 'true')
      }
    })

    let style = `
      <style>
        #ks-marquee-${this.dataset.sectionId} ul {
          animation-name: ks-marquee-animation-${this.dataset.sectionId};
          animation-duration: ${this.dataset.animationDuration}s;
        }
        @keyframes ks-marquee-animation-${this.dataset.sectionId} {
          to { transform: translateX(-${marqueeWidth}px); }
        }
      </style>
    `
    if (this.dataset.marqueeDirection === 'right') {
      style += `
        <style>
          @keyframes ks-marquee-animation-${this.dataset.sectionId} {
            from { transform: translateX(-${marqueeWidth}px); }    
            to { transform: 0); }    
          }
        </style>
      `
    }

    this.insertAdjacentHTML('beforeBegin', style)
  }
}
customElements.define('ks-marquee', KsMarquee)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-media-slider"] && !Shopify.designMode) return;
  try {
    
class KsMediaSlider extends HTMLElement {
  constructor () {
    super()

    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=')
      script.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(script)
    }

    this.myInterval = setInterval(() => {
      this.init()
    }, 500);

    document.addEventListener('shopify:section:load', () => {
      if (event.target.querySelector('.ks-media-slider')) {
        this.init()
      }
    })
  }

  init () {
    if (!window.Swiper) return

    const slider = new window.Swiper(this.querySelector('.swiper'), {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
      on: {
        slideChange: (swiper) => {
          this.querySelectorAll('.swiper-slide').forEach(slide => {
            if (!slide.classList.contains('swiper-slide-visible')) {
              slide.querySelectorAll('.video').forEach(video => {
                video.pause()
              })
              slide.querySelectorAll('iframe').forEach(iframe => {
                const iframeSrc = iframe.src
                iframe.src = iframeSrc
              })
            }
          })
        }
      }
    })

    const lazyVideosObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play()
        }
      })
    }, { rootMargin: '0px 0px 300px 0px' })
    
    this.querySelectorAll('video[data-autoplay="true"]').forEach((el) => {
      lazyVideosObserver.observe(el)
    })

    clearInterval(this.myInterval)
  }
}
customElements.define('ks-media-slider', KsMediaSlider)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-testimonials-slider"] && !Shopify.designMode) return;
  try {
    
class KsTestimonialsSlider extends HTMLElement {
  constructor () {
    super()
 
    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      document.head.appendChild(script)
    }

    setTimeout(() => { 
      this.slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())
    }, 500)
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    /** @type {SwiperOptions} */
    const options = {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
    }
    return options
  }

}
customElements.define('ks-testimonials-slider', KsTestimonialsSlider)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-carousel"] && !Shopify.designMode) return;
  try {
    

    // DOM Queries
    const mpPanelContainer = document.querySelector('.mp__panel-container');
    const mpPanels = document.querySelectorAll('.mp__panel[data-img-srcset]');
    const mpPanelImg = document.querySelector('.mp__panel-img');

    // Add First Image
    /*
    if (mpPanels.length > 0) {
        const firstImgSrc = mpPanels[0].dataset.imgSrc;
        mpPanelImg.src = firstImgSrc;
    }
    */

    // Grab and Scroll Functionality
    let isDown = false;
    let startX;
    let scrollLeft;

    mpPanelContainer.addEventListener('mousedown', function(e) {
        isDown = true;
        startX = e.pageX - mpPanelContainer.offsetLeft;
        scrollLeft = mpPanelContainer.scrollLeft;
        mpPanelContainer.style.cursor = 'grabbing';
    });

    mpPanelContainer.addEventListener('mouseleave', () => {
        isDown = false;
        mpPanelContainer.style.cursor = 'grab';
    });

    mpPanelContainer.addEventListener('mouseup', () => {
        isDown = false;
        mpPanelContainer.style.cursor = 'grab';
    });

    let x;
    let walk;
    mpPanelContainer.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        x = e.pageX - mpPanelContainer.offsetLeft;
        walk = (x - startX);
        mpPanelContainer.scrollLeft = scrollLeft - walk;
    });

    // Event Delegation: Attach event listener to parent element
    mpPanelContainer.addEventListener('click', function(e) {
        // Prevent default behaviour
        e.preventDefault();

        if (this.style.cursor === 'grabbing') return;

        // Get the closest node by class of the selected element
        const clicked = e.target.closest('.mp__panel');

        // If clicked is not defined then it will immediately finished
        if (!clicked) return;

        // Remove active class from all panels before adding it to the active one
        mpPanels.forEach(panel => panel.classList.remove('mp__panel--active'));

        // Add active class to the target element
        clicked.classList.add('mp__panel--active');

        // Get dataset src of image
        const newImgSrcset = clicked.dataset.imgSrcset;
        console.log('New image source set:');
        console.log(newImgSrcset);

        // Replace image src
        mpPanelImg.srcset = newImgSrcset;

    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-dawn-testimonials-slider"] && !Shopify.designMode) return;
  try {
    
class MpTestimonialsSlider extends HTMLElement {
  constructor () {
    super()
 
    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      document.head.appendChild(script)
    }

    setTimeout(() => { 
      this.slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())
    }, 500)
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    /** @type {SwiperOptions} */
    const options = {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
    }
    return options
  }

}
customElements.define('mp-testimonials-slider', MpTestimonialsSlider)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-hero-slides"] && !Shopify.designMode) return;
  try {
    
  class CausesHeroSlideshow extends HTMLElement {
    constructor() {
      super();

      if (!document.querySelector('#swiper-stylesheet')) {
        const stylesheet = document.createElement('link');
        stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css');
        stylesheet.setAttribute('rel', 'stylesheet');
        stylesheet.setAttribute('id', 'swiper-stylesheet');
        stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=');
        stylesheet.setAttribute('crossorigin', 'anonymous');
        document.head.appendChild(stylesheet);
      }

      if (!document.querySelector('#swiper-script')) {
        const script = document.createElement('script');
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js');
        script.setAttribute('id', 'swiper-script');
        script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=');
        script.setAttribute('crossorigin', 'anonymous');
        document.head.appendChild(script);
      }

      this.initInterval = setInterval(() => {
        this.init();
      }, 100);

      document.addEventListener('shopify:section:load', () => {
        if (event.target.querySelector('.causes-hero-slideshow')) {
          this.init();
        }
      });
    }

    init() {
      if (!window.Swiper) return;

      const sliderElem = this.querySelector('.swiper');
      const progressBar = this.querySelector('.progress-bar');

      const navigation = {
        enabled: sliderElem.dataset.swiperNavigation === 'true',
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      };

      const pagination = {
        enabled: sliderElem.dataset.swiperPagination === 'thumbnails',
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        renderBullet: function (index, className) {
          const slideData = JSON.parse(sliderElem.dataset.slideData);
          const slide = slideData[index];
          const isMobile = window.innerWidth < 750;
          const imageUrl = isMobile ? slide.mobile_image : slide.desktop_image;

          return `<span class="${className}" style="background-image: url('${imageUrl}')"></span>`;
        },
      };

      const autoplay =
        sliderElem.dataset.swiperAutoplay === '0'
          ? undefined
          : {
              delay: Number(sliderElem.dataset.swiperAutoplay) * 1000,
              disableOnInteraction: false,
            };

      this.slider = new window.Swiper(sliderElem, {
        navigation,
        pagination,
        effect: 'fade',
        speed: Number(sliderElem.dataset.swiperSpeed || 800),
        autoplay,
        loop: true,
        fadeEffect: { crossFade: true },
        on: {
          autoplayTimeLeft(s, time, progress) {
            if (progressBar) {
              progressBar.style.width = (1 - progress) * 100 + '%';
            }
          },
        },
      });

      clearInterval(this.initInterval);
    }
  }
  customElements.define('causes-hero-slideshow', CausesHeroSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-marquee"] && !Shopify.designMode) return;
  try {
    
class MpMarquee extends HTMLElement {
  constructor () {
    super()

    this.init()

    document.addEventListener('shopify:section:load', (e) => {
      console.log(e.target) 
      if (e.target.querySelector('.mp-marquee')) {
        init()
      }
    })
  }

  init () {
    const list = this.querySelector('ul')
    console.log(list)
    const marqueeWidth = list.scrollWidth
    console.log(list.scrollWidth)
    const marqueeLength = list.querySelectorAll('li').length 

    list.insertAdjacentHTML('beforeEnd', list.innerHTML)

    list.querySelectorAll('li').forEach((item, index) => {
      if (index >= marqueeLength) {
        item.setAttribute('aria-hidden', 'true')
      }
    })

    let style = `
      <style>
        #mp-marquee-${this.dataset.sectionId} ul {
          animation-name: mp-marquee-animation-${this.dataset.sectionId};
          animation-duration: ${this.dataset.animationDuration}s;
        }
        @keyframes mp-marquee-animation-${this.dataset.sectionId} {
          to { transform: translateX(-${marqueeWidth}px); }
        }
      </style>
    `
    if (this.dataset.marqueeDirection === 'right') {
      style += `
        <style>
          @keyframes mp-marquee-animation-${this.dataset.sectionId} {
            from { transform: translateX(-${marqueeWidth}px); }    
            to { transform: 0); }    
          }
        </style>
      `
    }

    this.insertAdjacentHTML('beforeBegin', style)
  }
}
customElements.define('mp-marquee', MpMarquee)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-product-tabs"] && !Shopify.designMode) return;
  try {
    
  const tabs = document.querySelectorAll('.mp-tab-button');
  const tabContents = document.querySelectorAll('.mp-tab-content');

  tabs.forEach((tab, tabIndex) => {
    tab.addEventListener('click', () => {
      tabs.forEach((el, i) => {
        if (tabIndex === i) {
          el.classList.add('active');
        } else {
          el.classList.remove('active');
        }
      });

      tabContents.forEach((el, contentIndex) => {
        if (contentIndex === tabIndex) {
          el.classList.add('active');
        } else {
          el.classList.remove('active');
        }
      });

      if (tabIndex === 0) {
        tabs[0].click(); // on 1st load activate
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
